export function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <div className="flex items-end justify-between mb-8 gap-4 flex-wrap">
      <div>
        {eyebrow && <div className="eyebrow mb-2">{eyebrow}</div>}
        <h1 className="font-display text-3xl sm:text-4xl">{title}</h1>
        {subtitle && <p className="text-sm text-[#5C626A] mt-2 max-w-xl">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}

export function KPI({ label, value, sub, accent, testid }) {
  const color = { gold: "#B38E46", sage: "#2D5A3C", terra: "#A3411D", ink: "#0E1B2E" }[accent] || "#1A1D20";
  return (
    <div className="card p-5 fade-up" data-testid={testid}>
      <div className="eyebrow mb-3">{label}</div>
      <div className="font-num text-2xl" style={{ color }}>{value}</div>
      {sub && <div className="text-xs text-[#8C929B] mt-1.5">{sub}</div>}
    </div>
  );
}

export function Empty({ children }) {
  return <div className="text-center py-16 text-[#8C929B] text-sm">{children}</div>;
}

export function PeriodPicker({ presets, value, onChange }) {
  const active = presets.find((p) => p.start === value.start && p.end === value.end)?.id;
  return (
    <div className="flex items-end gap-2 flex-wrap" data-testid="period-picker">
      <div className="flex gap-1 bg-white border border-[#E6E1D8] rounded-full p-1 flex-wrap">
        {presets.map((p) => (
          <button key={p.id} onClick={() => onChange({ start: p.start, end: p.end })} data-testid={`period-${p.id}`}
            className={`px-3 py-1.5 rounded-full text-xs transition-colors ${active === p.id ? "bg-[#0E1B2E] text-white" : "text-[#5C626A] hover:bg-[#F4F0EA]"}`}>
            {p.label}
          </button>
        ))}
      </div>
      <input type="date" className="field w-auto py-1.5 text-xs" value={value.start} onChange={(e) => onChange({ ...value, start: e.target.value })} aria-label="From" />
      <span className="text-xs text-[#8C929B] pb-2">to</span>
      <input type="date" className="field w-auto py-1.5 text-xs" value={value.end} onChange={(e) => onChange({ ...value, end: e.target.value })} aria-label="To" />
    </div>
  );
}

export function Section({ title, action, children, className = "" }) {
  return (
    <div className={`card overflow-hidden ${className}`}>
      <div className="flex items-center justify-between px-5 py-3.5 border-b border-[#E6E1D8]">
        <h3 className="font-display text-lg">{title}</h3>
        {action}
      </div>
      {children}
    </div>
  );
}
